import logoM from './img/cab/logo-285px-70px.png';
import './css/bootstrap.min.css';
import './css/estilo.css';
import Menu from './Menu';
import { useMsal } from "@azure/msal-react";


const Master = ({ name, username, children }) => {

    const capitalLetter = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/" // Cambia "/login" por la ruta que desees
        });
    };

    return (
        <div className="wpr-general">
            {/* CABECERA  */}
            <header className="cab">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-8 col-lg-4 col-xxl-3 col-logo">
                            <div className="navbar-brand">
                                <img src={logoM} className="" width="285" height="70" alt="Universidad Apec - Unapec" />
                            </div>
                        </div>
                        <div className="col-4 col-lg-8 col-xxl-9">
                            <nav className="wpr-nav d-flex align-items-center ms-auto">
                                {/* usuario */}
                                <div className="opc-usuario ms-auto">
                                    <button className="abrir-panel-usuario" aria-hidden="true"><span className="visually-hidden">Acceder al menú de usuario</span></button>

                                    <div className="panel-usuario oculto-moviles">
                                        <button className="cerrarPanel" aria-hidden="true">&#x2715;</button>
                                        <div className="nombre"> {capitalLetter(name)} </div>
                                        <span style={{ color: '#d3d3d3', float: 'right' }}>{username}</span>
                                        <button onClick={handleLogout} className="btn cerrarSesion" title="Cerrar sesión"><span>cerrar sesión</span></button>
                                    </div>
                                </div>
                                {/* menu */}
                                <div className="d-none">
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
            <div className="bg-header"></div>


            {/* CUERPO  */}
            <div className="wpr-cuerpo h-100">
                <div className="cuerpo h-100 flex-grow-1">
                    <div className="container-fluid h-100">
                        <div className="row h-100">

                            {/* LATERAL */}
                            <div className="col-lg-4 col-xxl-3 col-lateral">
                                <div className="lateral">
                                    {<Menu />}
                                </div>
                            </div>


                            {/* down */}
                            <div className="col-lg-8 col-xxl-9 col-contenido">
                                <div className="contenido">
                                    {children}
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



export default Master;